<script lang="ts">
	import type { PageData } from './$types';
	import { onMount } from 'svelte';
	import { storyblokEditable, useStoryblokBridge } from '@storyblok/svelte';
	import { getCMSComponents } from '@app/components/cms';
	import { checkCMSBanner } from '@app/utils/cms';
	import PageHead from '@app/components/PageHead.svelte';
	import ButtonSVG from '$lib/elements/buttons/variants/ButtonSVG.svelte';
	import ButtonBoxTextColor from '$lib/elements/buttons/variants/ButtonBoxTextColor.svelte';
	import { goto } from '$app/navigation';
	import { urls } from '@app/urls';
	import { capitalize } from '$lib/utils/strings';
	import { bannersHeight } from '@app/stores/banners';
	import { page } from '$app/stores';
	import { t } from 'svelte-i18n';

	export let data: PageData;

	$: data.story?.content.banner && checkCMSBanner(data.story?.content.banner);

	onMount(async () => {
		if (data.story) {
			useStoryblokBridge(
				data.story.id,
				async (newStory) => {
					data.FullCMSComponents = await getCMSComponents(newStory.content.body);
				},
				{
					preventClicks: true
				}
			);
		}
	});
</script>

{#if data.story?.content}
	<PageHead title={data.story.content.metaTitle} desc={data.story.content.metaDescription} />

	{#if !$page.data?.user}
		<div class="lg:hidden container py-4 sticky bg-white z-30" style={`top:${$bannersHeight}px`}>
			<div class="flex items-center justify-between">
				<ButtonSVG
					props={{
						href: '/',
						classNames: 'block text-primary lg:hidden flex-shrink-0',
						iconClassNames: '!w-[108px] !h-[38px]',
						name: 'logo_wiseed_baseline'
					}}
				/>
				<ButtonBoxTextColor
					props={{
						label: capitalize($t('signUp')),
						size: 'small'
					}}
					on:click={async () => {
						await goto(urls.SIGNUP);
					}}
				/>
			</div>
		</div>
	{/if}

	<div use:storyblokEditable={data.story?.content} class="landing-page">
		{#if data.FullCMSComponents.length}
			{#each data.FullCMSComponents as comp}
				<section class={comp.CMSComp.component === 'stats' ? 'overflow-hidden' : ''}>
					<svelte:component this={comp.svelteComp} blok={comp.CMSComp} />
				</section>
			{/each}
		{/if}
	</div>
	<slot />
{/if}

<style lang="postcss">
	:global (section:has(.benefits) + section > div) {
		@apply pt-[300px] md:pt-[150px] lg:pt-[130px];
	}
</style>
